import React, { useState } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import PropTypes from 'prop-types'
import * as rotativeInventoryActions from 'action/rotativeInventory';
import * as reportActions from 'action/report';
import { formatColumnsByType } from 'utils/formatColumnsByType'
import CommonReport from 'component/newCommonReport/newCommonReport';
import columns from './columns';

let signalController;

const ZeroCostDpacItems = ({
  auth,
  translate,
  fetchZeroCostDpacItems,
  fetchFluxReport,
}) => {
  const [formData, setFormData] = useState({});

  const formFields = [
    {
      type: 'branchs',
      name: 'idBranches',
      label: translate('field.store'),
      help_text: translate('totalAccuracy.store'),
      required: false,
    },
    {
      type: 'sections',
      name: 'lsSections',
      help_text: translate('irc.choose-section'),
      label: translate('section'),
      required: false,
    },
    {
      type: 'new_ds_ldap',
      name: 'cdLm',
      isLm: true,
      help_text: translate('mobile.hint.lm'),
      label: translate('field.lm.hint'),
      required: false,
    },
    {
      type: 'date_range',
      name: 'dtPeriod',
      label: translate('field.period.hint'),
      help_text: translate('totalAccuracy.dtYear.filter'),
      required: true,
    },
  ];

  const onSubmit = (data, setResponseInTable) => {
    const [dtStart, dtEnd] = data.dtPeriod;
    const formattedData = {
      ...formData,
      ...data,
      dtStart: moment(dtStart).format('DD/MM/YYYY'),
      dtEnd: moment(dtEnd).format('DD/MM/YYYY'),
      size: data.limit,
      hasPagination: true,
    };

    setFormData(formattedData);
    delete formattedData.dtPeriod;

    signalController = new AbortController();

    const abort = () => {
      signalController.abort();
    };

    fetchZeroCostDpacItems(auth.user.dsToken, formattedData, (response,count) => {

      const valuesFormattedByTypes = formatColumnsByType(
        columns,
        response,
        translate
      )
      
      setResponseInTable({ total: count, data: valuesFormattedByTypes })


    }, abort, signalController)
  };

  const onExport = () => {
    const values = {
      tpReport: 44,
    };

    signalController = new AbortController();

    const formattedValues = {...formData};

    fetchFluxReport(auth.user.dsToken, values, formattedValues)
  };


  return (
    <div className="zero-cost-dpac-items">
      <CommonReport
        isFlux
        user={auth.user}
        translate={translate}
        title={translate('zerocost-dpac-items.subtitle')}
        onSubmit={onSubmit}
        fields={formFields}
        label={" "}
        columns={columns}
        onExport={onExport}
        emptyReportMsg='no.data.found'
        customEmptyText={true}
        order
        defaultOrder={"dtInventory"}
      />
    </div>
  );
};


const mapStateToProps = ({ rotativeInventoryReducer, paginateReducer, reportReducer }) => ({
  count: paginateReducer.count,
  current: paginateReducer.current,
  error: reportReducer.get.error,
  pages: paginateReducer.pages,
  records: rotativeInventoryReducer.records,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { ...rotativeInventoryActions, ...reportActions },
    dispatch
  );

ZeroCostDpacItems.propTypes = {
  auth: PropTypes.object.isRequired,
  fetchZeroCostDpacItems: PropTypes.func,
  error: PropTypes.object,
  count: PropTypes.number.isRequired,
  records: PropTypes.array.isRequired,
  fetchFluxReport: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate(null, { wait: true, translateFuncName: 'translate' })(ZeroCostDpacItems));
